import { useSearchParams } from '@/hooks/useSearchParams';
import { useLoginWithTokenQuery } from '@/queries/auth.queries';

export function useLoginWithTokenPageController() {
	const params = useSearchParams();
	const token = params.get('token');

	const query = useLoginWithTokenQuery({ token });

	if (!query.isSuccess) {
		alert('FUNCIONA, REDIRECT');
	}

	return {
		query,
	};
}
